import { useQuery } from '@tanstack/react-query';
import { axiosClient } from '../axiosClient';

export const getAdPdf = async (prospectUrl: string | null): Promise<string | null> => {
  if (!prospectUrl) return null;

  // Extract the path and query parameters from the full URL
  // prospectUrl might be like "https://api.valueguard.se/v1/ads/pdf?ad_id=123"
  // We need to extract "/v1/ads/pdf?ad_id=123"
  let url = prospectUrl;

  // If it's a full URL, extract just the path and query string
  if (prospectUrl.startsWith('http://') || prospectUrl.startsWith('https://')) {
    try {
      const urlObj = new URL(prospectUrl);
      url = urlObj.pathname + urlObj.search;
    } catch (e) {
      // If URL parsing fails, use the original string
      url = prospectUrl;
    }
  }

  const { data } = await axiosClient.get(url, {
    responseType: "blob"
  });

  const pdfUrl = window.URL.createObjectURL(new Blob([data], { type: 'application/pdf' }));
  return pdfUrl;
}

const useAdPdf = (prospectUrl: string | null) => {
  return useQuery({
    queryKey: ['ad-pdf', prospectUrl],
    queryFn: () => getAdPdf(prospectUrl),
    enabled: !!prospectUrl,
  });
}

export default useAdPdf;